import React, { useEffect, useState, useRef } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "../../../components/UI/button";
import { useSystem } from "../../../hooks/use-system";
import { defaultLanguage } from "../../../constants/languages";
import { Form } from "../../../components/UI/form";
import {
  isValidPhoneNumber,
  getCountryCallingCode,
} from "react-phone-number-input";
import { LoaderVectors } from "../../../constants/icons";

const FormSchema = z.object({
  phonenumber: z
    .string()
    .min(8, { message: "" })
    .refine((value) => isValidPhoneNumber(value), {
      message: "",
    }),
});
export function InputForm({
  popUpText,
  config,
  language,
  setStep,
  handleVerificationRequest,
  handleCarrierCode,
}) {
  const [countrySelected, setCountrySelected] = useState("");
  const [agreed, setAgreed] = useState(
    config.terms_checkbox_switch ? config.default_terms_switch_status : true
  );
  const ref = useRef(null);
  const [shown, showPopover] = useState(false);
  const target = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const system = useSystem();
  const form = useForm({
    resolver: zodResolver(FormSchema),
    mode: "onChange",
    defaultValues: {
      phonenumber: countrySelected,
    },
  });

  const isTesting = config.is_testing;

  useEffect(() => {
    if (config.country_code) {
      const country = getCountryCallingCode(config.country_code?.toUpperCase());
      setCountrySelected(country);
      form.setValue("phonenumber", `+${country}`);
    }
  }, [config.country_code, form]);

  function onSubmit(data) {
    console.log("Submit button clicked");
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full max-w-md flex flex-col justify-center items-center gap-3 mt-3"
      >
        {popUpText && (
          <div
            className={`relative rounded-lg px-3 ${
              !form.formState.isValid && config.animation_enabled
                ? "animate-[wiggle_1s_ease-in-out_infinite]"
                : ""
            }`}
          >
            <p
              className="text-sm text-center font-semibold m-0"
              style={{
                color: config.text_color || "#000",
              }}
              dangerouslySetInnerHTML={{ __html: popUpText }}
            ></p>
          </div>
        )}

        <div className="hidden md:flex justify-center items-center w-full">
          <span
            className="text-sm"
            style={{
              color: config.text_color || "#000",
            }}
          >
            {config.texts?.[language || defaultLanguage]?.[0]?.button_caption ||
              ""}
          </span>
        </div>

        <Button
          className={`flex flex-row gap-2 sm:h-[98px] h-[60px] px-5 py-4 w-full cursor-pointer 
            font-semibold text-lg md:text-2xl rounded-full tracking-wider`}
          style={{
            backgroundColor: config.button_primary_color || "#e02f1fe3",
            color: config.button_text_color || "#000",
            fontSize: config.button_font_size,
          }}
          type="submit"
        >
          {loading ? (
            <>
              <span className="animate-spin">
                <LoaderVectors />
              </span>
              <div className="flex flex-row justify-end items-center">
                <p
                  className="m-0"
                  style={{ fontSize: config.button_font_size }}
                >
                  {
                    config.texts?.[language || defaultLanguage]?.[0]
                      .button_loading_text
                  }
                </p>
                <span className="animate-bounce">.</span>
                <span className="animate-bounce delay-200">.</span>
                <span className="animate-bounce delay-300">.</span>
              </div>
            </>
          ) : (
            config.texts?.[language || defaultLanguage]?.[0]?.button_text || ""
          )}
        </Button>
      </form>
    </Form>
  );
}
